import { Select } from 'antd'
import { useTranslation } from 'react-i18next'

import { useDashboardFilters } from '@contexts'
import { IncotermGoupEnum } from '@types'

import { FilterGroup } from './styled'

const tripTypeOptions = [
  { labelKey: 'admin_router.dashboard.trip_type_fob', value: IncotermGoupEnum.FOB },
  { labelKey: 'admin_router.dashboard.trip_type_cfr', value: IncotermGoupEnum.CFR },
]

const TripTypeSelector = () => {
  const { t } = useTranslation()
  const { tripType, setTripType } = useDashboardFilters()

  return (
    <FilterGroup>
      <Select
        style={{ minWidth: 200 }}
        value={tripType}
        onChange={v => setTripType(v as IncotermGoupEnum)}
        options={tripTypeOptions.map(({ labelKey, value }) => ({
          label: t(labelKey),
          value,
        }))}
      />
    </FilterGroup>
  )
}

export { TripTypeSelector }
